import { render } from "./AddExamQuestionDialog.vue?vue&type=template&id=291e9984&scoped=true&ts=true"
import script from "./AddExamQuestionDialog.vue?vue&type=script&lang=ts"
export * from "./AddExamQuestionDialog.vue?vue&type=script&lang=ts"

import "./AddExamQuestionDialog.vue?vue&type=style&index=0&id=291e9984&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-291e9984"]])

export default __exports__